import {
  Button,
  Form,
  Input,
  DatePicker,
  Radio,
  Upload,
  UploadFile,
} from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { IAddNewChildType } from '../..';
import styles from './AddNewChildForm.module.scss';
import { forwardRef, useImperativeHandle } from 'react';

interface Props {
  onFinish: (values: IAddNewChildType) => void;
  onFinishFailed: (errorInfo: any) => void;
  setFileList: (fileList: UploadFile[]) => void;
  fileList: UploadFile[];
}

export interface AddNewChildFormRef {
  resetForm: () => void;
}

const AddNewChildForm = forwardRef<AddNewChildFormRef, Props>(({
  onFinish,
  onFinishFailed,
  setFileList,
  fileList,
}, ref) => {
  const [form] = Form.useForm();

  useImperativeHandle(ref, () => ({
    resetForm: () => {
      form.resetFields();
      setFileList([]);
    }
  }));

  return (
    <Form
      form={form}
      name="childForm"
      labelCol={{ span: 6 }}
      wrapperCol={{ span: 18 }}
      style={{ maxWidth: 600 }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      labelAlign="left"
      requiredMark={false}
      className={styles.formWrapper}
      autoComplete="off">
      <Form.Item<IAddNewChildType>
        label="Name"
        name="childName"
        className={styles.formItem}
        rules={[{ required: true, message: 'Please enter a name' }]}>
        <Input className={styles.childInput} />
      </Form.Item>

      <Form.Item<IAddNewChildType>
        label="Birth date"
        name="birthDate"
        className={styles.formItem}
        rules={[{ required: true, message: 'Please select birth date' }]}>
        <DatePicker className={styles.childInput} style={{ width: '100%' }} />
      </Form.Item>

      <Form.Item<IAddNewChildType>
        label="Gender"
        name="gender"
        rules={[{ required: true, message: 'Please select a gender' }]}>
        <Radio.Group>
          <Radio value="4">Boy</Radio>
          <Radio value="5">Girl</Radio>
        </Radio.Group>
      </Form.Item>

      <Form.Item<IAddNewChildType>
        label="Photo"
        name="photo"
        rules={[{ required: false, message: 'Please select a Photo' }]}
        valuePropName="fileList"
        getValueFromEvent={(e) => e && e.fileList}>
        <Upload
          maxCount={1}
          listType="picture-card"
          className={styles.uploader}
          beforeUpload={() => false}
          multiple={false}
          accept="image/*">
          {fileList.length >= 1 ? null : (
            <div>
              <PlusOutlined />
            </div>
          )}
        </Upload>
      </Form.Item>

      {/* دکمه ارسال */}
      <Form.Item wrapperCol={{ offset: 0, span: 24 }}>
        <Button
          className={styles.submit_button}
          block
          type="primary"
          htmlType="submit">
          Add Child
        </Button>
      </Form.Item>
    </Form>
  );
});

AddNewChildForm.displayName = 'AddNewChildForm';

export default AddNewChildForm;
